import React, { useState, useEffect } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import ChatModal from "./ChatModal";
import COLORS from "../../../assets/Colors";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import "./Timeline.css";
import EventService from "../../../services/EventService";
import useViewer from "../../../hooks/useViewer";
import VideoBox from "../../common/VideoBox";
import { navigate, useLocation } from "@reach/router";
import useLoader from "../../../hooks/useLoader";
import { DrawerContainer } from "../Register";
import VideoPlayer from "../../common/Video";
import CustomAudioPlayer from "../../schedules/AudioPlayer/CustomAudioPlayer";
import CustomAudioPlayerImage from "../../schedules/AudioPlayer/CustomAudioPlayerImage";
import { Header } from "../Header/Header";
import { Layout } from "../GalleryViewRoute";
import MenuBurger from "../../common/ActionBar/MenuBurger";
import { HeroContainer } from "../Register";
import FAQs from "../../schedules/MenuBar/Faqs";
import { Modal } from "@material-ui/core";

const AgmLive = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { setGlobalState } = useViewer();
  const [userData, setUserData] = useState();
  const location = useLocation();
  const { setLoader } = useLoader();
  const [modal, setModal] = useState({ state: false });

  const params = new URLSearchParams(window.location.search);
  let eventId = params.get("eventId");
  if (eventId) {
    localStorage.setItem("eventId", eventId);
  } else {
    eventId = localStorage.getItem("eventId");
  }
  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching agm event..." });
        const response = await EventService.getEvent(eventId, "live");
        setUserData(response);
        setGlobalState(response);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
        if (err.errorCode === "ER-UNAUTHORISED-USER") {
          navigate(location.pathname);
        }
      } finally {
        setLoader({ state: false });
      }
    }
    getEventInfo(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eventId) {
      (async function getQnADashboard() {
        try {
          const response = await EventService.eventInfoEventViewerLive(
            eventId,
            "live",
          );
          if (response) {
            setUserData(response);
            setGlobalState(response);
          }
        } catch (err) {
          if (err.errorCode === "ER-UNAUTHORISED-USER") {
            navigate(location.pathname);
          }
        }
      })();
    }
  }, [eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  const { galleryView } = userData?.livepage || {};
  // Define condition in a variable

  const actions = [
    {
      text: "Home",
      props: {
        onClick: () => {
          navigate(`#home`);
        },
      },
    },
    {
      text: userData?.livepage?.livePageSettings.communicateTabLabel,
      props: {
        onClick: () => {
          if (window.location.hash === "" || window.location.hash === "#home") {
            setModal({ state: true });
          }
        },
        // disabled:

        //   window.location.hash !== "#home",
      },
      hidden:
        !userData?.livepage?.livePageSettings.communicateTab ||
        (location.hash !== "" && location.hash !== "#home"),
    },

    {
      text: "FAQs",
      props: {
        onClick: () => {
          navigate(`#faqs`);
        },
      },
    },
    {
      text: "Help",
      props: {
        onClick: () => {
          window.location.hash = "#help";
        },
      },
    },
  ];

  return (
    <Layout
      image={userData?.theme?.themeGeneral?.backgroundImage}
      bgColor={userData?.theme?.themeGeneral?.bodyBackgroundColor}
    >
      {userData?.general?.eventTemplate === "AGM" && (
        <MenuBurger
          {...{ actions }}
          signOut={false}
          align={true}
          color={userData?.theme?.themeNavigationBar?.menuButtonTextColor}
          hoverColor={userData?.theme?.themeNavigationBar?.menuButtonHoverColor}
          menuBackgroundColor={
            userData?.theme?.themeNavigationBar?.menuButtonBgColor
          }
          activeMenuButtonBgColor={
            userData?.theme?.themeNavigationBar?.activeMenuButtonBgColor
          }
          activeMenuButtonTextColor={
            userData?.theme?.themeNavigationBar?.activeMenuButtonTextColor
          }
        />
      )}
      <Header showHeader={false}>
        {userData?.general?.eventTemplate !== "AGM" ? (
          userData?.general?.eventTitle ? (
            <WidthMax id="about">
              <DrawerContainer>
                <h2>Agm is not available for this event</h2>
              </DrawerContainer>
            </WidthMax>
          ) : null
        ) : (
          // <WidthMax
          //   // id="about"
          //   style={{
          //     //  marginTop: "60px",
          //   }}
          // >

          <HeroContainer>
            <Center>
              {userData?.general?.eventStatus === "inactive" &&
              (userData?.general?.playbackInfo?.playbackRequired === false ||
                !userData?.general?.playbackInfo?.playbackRequired) ? (
                <OuterContainer>
                  <DrawerContainer>
                    <h2>Your event is inactive</h2>
                  </DrawerContainer>
                </OuterContainer>
              ) : location.href.includes("faqs") ? (
                <FAQs data={userData?.faq?.faq} />
              ) : (
                <>
                  {window.location.href.includes("help") ? (
                    <div id="help">
                      <FAQs data={userData?.help?.help} help={true} />
                    </div>
                  ) : window.location.href.includes("communicate") ? (
                    <div id="communicate">
                      {/* <VideoBox
                              {...{ modal, setModal, eventId }}
                              communicateFields={
                                userData?.communicate
                                  ?.communicateFields
                              }
                            /> */}
                    </div>
                  ) : (
                    <OuterContainer
                      checkAgm={galleryView?.showHeader ? true : false}
                    >
                      {userData?.general?.eventStatus === "inactive" &&
                      userData?.general?.playbackInfo?.playbackRequired &&
                      !userData?.general?.playbackInfo?.playbackVideo
                        ?.length ? (
                        <DrawerContainer>
                          <h2>Playback is getting ready for this event</h2>
                        </DrawerContainer>
                      ) : userData?.general?.eventStatus === "inactive" &&
                        userData?.general?.playbackInfo?.playbackRequired &&
                        userData?.general?.playbackInfo?.playbackVideo
                          ?.length ? (
                        // <Container>
                        <VideoWrapper>
                          {userData?.general?.playbackInfo?.playbackVideo && (
                            <VideoPlayer
                              src={
                                userData?.general?.playbackInfo?.playbackVideo
                              }
                            />
                          )}
                        </VideoWrapper>
                      ) : (
                        // </Container>
                        <Container>
                          {userData?.livepage?.livePageSettings
                            ?.contentFormat === "video"
                            ? userData?.livepage?.liveStreamSettings
                                .filter((item) => item?.label === "Live Stream")
                                .map((stream) => (
                                  <VideoCard>
                                    <VideoBox
                                      src={
                                        stream?.liveStreamPlayerUrl
                                          ? stream?.liveStreamPlayerUrl
                                          : ""
                                      }
                                    />
                                    {/* <VideoPlayer
                                          src={stream?.liveStreamPlayerUrl}
                                        /> */}
                                  </VideoCard>
                                ))
                            : userData?.livepage?.livePageSettings
                                ?.contentFormat === "audio"
                            ? userData?.livepage?.liveStreamSettings
                                .filter((item) => item?.label === "Live Stream")
                                .map((stream) => (
                                  <CustomAudioPlayer
                                    src={
                                      stream?.liveStreamPlayerUrl
                                        ? stream?.liveStreamPlayerUrl
                                        : ""
                                    }
                                  />
                                ))
                            : userData?.livepage?.livePageSettings
                                ?.contentFormat === "audioWithStaticImage"
                            ? userData?.livepage?.liveStreamSettings
                                .filter((item) => item?.label === "Live Stream")
                                .map((stream) => (
                                  <CustomAudioPlayerImage
                                    image={
                                      userData?.livepage?.livePageSettings
                                        ?.uploadStaticImg
                                    }
                                    src={
                                      stream?.liveStreamPlayerUrl
                                        ? stream?.liveStreamPlayerUrl
                                        : ""
                                    }
                                  />
                                ))
                            : null}
                          {/* {modal?.state && (
                              <ChatModal
                                {...{ modal, setModal, eventId }}
                                communicateFields={
                                  userData?.communicate?.communicateFields
                                }
                              />
                            )} */}
                        </Container>
                      )}
                    </OuterContainer>
                  )}
                </>
              )}
            </Center>
          </HeroContainer>

          // </WidthMax>
        )}
      </Header>
      <>
        {modal?.state && (
          <Modal open={modal.state} onClose={() => setModal({ state: false })}>
            <div>
              <ChatModal
                {...{
                  modal,
                  setModal,
                  eventId,
                  communicateFields: userData?.communicate?.communicateFields,
                }}
              />
            </div>
          </Modal>
        )}
      </>
    </Layout>
  );
};

export default AgmLive;

export const OuterContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  //justify-content: center;
  //align-items: center;
  //padding-top: ${({ checkAgm }) => (checkAgm ? "0px" : "30px")};
  //padding-bottom: 10px;
  overflow: hidden;
  //position:fixed;
  bottom: 0;

  // @media ${theme.breakpoints.sm_up} {
  //   min-height: 90vh;
  // }
`;

export const Container = styled.div`
  border-radius: 11px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  @media (max-width: 600px) {
    width: 90%;
    padding: 30px 30px;
  }
  @media ${theme.breakpoints.sm_up} {
    width: 100%;
  }
`;

const VideoCard = styled.div`
  display: flex;
  margin: 28px 0;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  @media${theme.breakpoints.sm_up} {
    width: 70%;
  }
  @media ${theme?.breakpoints?.lg_up} {
    align-items: space-between;
  }
`;

const VideoWrapper = styled.div`
  width: 70%;
  margin: 0% 14%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  // @media ${theme.breakpoints.sm_up} {
  //   width: 90%;
  //   padding-right: 18px;
  // }

  // @media ${theme.breakpoints.lg_up} {
  //   width: 85%;
  //   margin-left: 68px;
  // }
`;

export const AboutUsBody = styled.section`
  /* height: 663px; */
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    height: unset;
  }
`;
export const GreySection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 60px 0 60px 0;
  align-items: center;
  background-color: #f9f9f9;
  width: 100vw;
`;
export const WhiteSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
`;

export const H2 = styled.h2`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 22px;
  margin-bottom: 32px;
  cursor: default;
  padding: 0 20px;
  margin: 0 auto;
  @media (max-width: 1024px) {
    font-size: 24px;
    text-align: center;
  }
`;

export const BodyWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 1%;
  color: ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontBold};
  width: 100%;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Loader = styled.div`
  align-items: center;
  justify-content: center;
`;

const Center = styled.div`
  width: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  overflow-y: ${({ isScrollable }) => (isScrollable ? "auto" : "hidden")};
  @media only screen and (max-width: 767px) {
    margin-left: 12px;
  }
`;

const WidthMax = styled.div`
  width: 100vw;
  min-height: 100vh;
`;
